import React, { useEffect, useState } from "react";


import dayjs from 'dayjs';
import advancedFormat from "dayjs/plugin/advancedFormat"
import buddhistEra from "dayjs/plugin/buddhistEra"
import InsertChartIcon from '@mui/icons-material/InsertChart';
import { AppBar, Button, Dialog, IconButton, Skeleton, Slide, TextField, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { SettingContext } from "../App";
import { Bar, BarChart, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useTheme } from "@emotion/react";


dayjs.extend(advancedFormat)
dayjs.extend(buddhistEra)

dayjs.updateLocale('th', {
    weekStart: 0,
    yearStart: 7
})

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

 
export function DashboardDialog(props) {
    const {open, setOpen}= props;
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { state } = React.useContext(SettingContext);
    const iaam = state.iaam
    
    const handleClose = () => { 
        setOpen(false)
    }
    const [isLoading, setIsLoading] = useState(false)
    const [isRiskLoading, setIsRiskLoading] = useState(false)
    const [caseData, setCaseData] = useState([])
    const [habitatRiskData, setHabitatRiskData] = useState([])
    const [otherRiskData, setOtherRiskData] = useState([])
    const [populace, setPopulace] = useState(100000)
    const [tmpPopulace, setTmpPopulace] = useState(100000)
    const [updateAt, setUpdateAt] = useState(undefined)
    const [popError, setPopError] = useState(false)
    const currentDate = dayjs().year(parseInt(state.setting.time_range.W.end.split("-")[0])).week(parseInt(state.setting.time_range.W.end.split("-")[1]))

    useEffect(() => {
        const fetchData = async () => {
            iaam.getAccessToken(async (err, access_token) => {
                if(!err){
                    setIsLoading(true)
                    // get Case
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json', 
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    let area_params = state.setting.display.area.selected === "TH" ? `&area=${state.setting.display.area.selected}` : `&area=${state.setting.display.area.selected}&${state.setting.display.area.selected.toLowerCase()}_code=${state.setting.display.area[state.setting.display.area.selected]}`

                    const data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/report_patients/situation_cases_count?year=${currentDate.year()}&week=${currentDate.week()}&per=${populace}${area_params}`, options);
                    const json = await data.json()
                    setCaseData(json)

                    const update_data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/d506/patient-updated-date`, options);
                    const update_at = await update_data.json()
                    setUpdateAt(update_at)
                    setIsLoading(false)
                }
            })
        }

        if(open){
            fetchData()
        }

    }, [open, populace])

    useEffect(() => {
        const fetchRiskData = async () => {
            iaam.getAccessToken(async (err, access_token) => {
                if(!err){
                    setIsRiskLoading(true)
                    // get Case
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json', 
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    let area_params = state.setting.display.area.selected === "TH" ? `&area=${state.setting.display.area.selected}` : `&area=${state.setting.display.area.selected}&${state.setting.display.area.selected.toLowerCase()}_code=${state.setting.display.area[state.setting.display.area.selected]}`

                    const data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/report/survey_place_count_risklevel?WM=W&start=${currentDate.year()}-01&end=${currentDate.year()}-${currentDate.week()}&DIST=false${area_params}`, options);
                    const json = await data.json()
                    const filteredMainPlan = json.filter((item) => {
                        return item.survey_model_id === 1;
                    });
                    const groupRisk = Object.groupBy(filteredMainPlan, ({ place_type_id }) => place_type_id);
                    let otherRisk = []
                    Object.keys(groupRisk).forEach(key => {
                        if(key === '1'){
                            setHabitatRiskData(groupRisk[key])
                        }
                        else{
                            otherRisk.push(groupRisk[key][0])
                        }
                    })
                    console.log(otherRisk)
                    setOtherRiskData(otherRisk)
                    setIsRiskLoading(false)
                }
            })
        }

        if(open){
            fetchRiskData()
        }

    }, [open])

    const handelDividerChange = (e) => {
        setTmpPopulace(e.target.value)
        if(e.target.value > 0){
            setPopError(false)
        }
        else setPopError("จำนวนประชากรต้องมีค่ามากกว่า 0")
        
    }

    const updateDivider = () => {
        setPopulace(tmpPopulace)
    }

    const getFieldNameByArea = (area) => {
        switch (area) {
            case "TH":
                return {"field": "th_name", "prefix": ""}
            case "DPC":
                return {"field": "dpc_name", "prefix": ""}
            case "PROV":
                return {"field": "prov_name", "prefix": "จ."}
            case "AMPHUR":
                return {"field": "amphur_name", "prefix": "อ."}
            case "TAMBON":
                return {"field": "tambon_name", "prefix": "ต."}
            default:
                return area;
        }
    }
    
 
    return (
        <Dialog fullScreen TransitionComponent={Transition} open={open} >
            <AppBar sx={{ position: 'fixed' }}>
                <Toolbar sx={{backgroundColor: "#FFF", color:"#000"}} >
                    <InsertChartIcon id="apps" className="h-6 w-6 text-lg mr-2 text-red-900" />
                    <Typography sx={{ flex: 1 }} className="text-lg" component="div">
                        Dashboard
                    </Typography>
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleClose}
                        >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                            className="h-5 w-5"
                        >
                            <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div className="w-full mx-auto max-w-7xl mt-16 p-4">
                <div className="my-4 md:p-4 grid md:border md:rounded border-gray-300 sm:border-b sm:pb-10">
                    <Typography variant="h6" className="mb-4">สถานการณ์โรคไข้เลือดออก {caseData.length > 0 ? `${getFieldNameByArea(state.setting.display.area.selected).prefix}${caseData[0][getFieldNameByArea(state.setting.display.area.selected).field]}` : ""} ณ สัปดาห์ที่ <strong className="text-red-900">{state.setting.time_range.W.end.split("-")[1]} พ.ศ. {currentDate.format("BBBB")}</strong> เปรียบเทียบ 5 ปีย้อนหลัง</Typography>
                    <Typography variant="subtitle2"><strong className="text-blue-800">อัพเดท</strong> {dayjs(updateAt?.updated_date).format("DD MMMM BBBB")}</Typography>
                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-row gap-4 my-4">
                                <TextField id="populace" className="w-[200px]"
                                    label="อัตราป่วยต่อประชากร (ราย)" 
                                    variant="outlined" 
                                    type="number" 
                                    size="small"
                                    defaultValue={populace}
                                    onChange={handelDividerChange}
                                    helperText={popError? popError : ""}
                                    error={popError}
                                />
                                <Button size="small" hidden={populace === tmpPopulace} onClick={updateDivider}>อัพเดท</Button>
                            </div>
                            <>
                                <Typography variant="h3" color={caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? "#b73238": "#117554"}>{isLoading? <Skeleton animation="wave" width="150px"/> : `${caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? +(caseData.at(-1)?.cases_count/caseData.at(-2)?.cases_count).toFixed(2): -(caseData.at(-2)?.cases_count/caseData.at(-1)?.cases_count).toFixed(2)}`}</Typography>
                                <Typography variant="subtitle2">จำนวนผู้ป่วย พ.ศ. {caseData.at(-1)?.year} {caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? "มากกว่า": "น้อยกว่า"} พ.ศ. {caseData.at(-2)?.year} ณ. ช่วงเวลาเดียวกัน <strong className={caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? "text-[#b73238]": "text-[#117554]"}>{caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? (caseData.at(-1)?.cases_count-caseData.at(-2)?.cases_count).toLocaleString('en-US'): (caseData.at(-2)?.cases_count-caseData.at(-1)?.cases_count).toLocaleString('en-US')}</strong> ราย คิดเป็น <strong className={caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? "text-[#b73238]": "text-[#117554]"}>{caseData.at(-1)?.cases_count > caseData.at(-2)?.cases_count? +(caseData.at(-1)?.cases_count/caseData.at(-2)?.cases_count).toFixed(2): -(caseData.at(-2)?.cases_count/caseData.at(-1)?.cases_count).toFixed(2)}</strong> เท่า</Typography>

                            </>  
                            
                        </div>
                        <div className="w-full my-3 md:col-span-2 h-[400px] font-normal text-sm">
                            <ResponsiveContainer id="case-count-area-cumulative" width="100%" height="100%">
                                <ComposedChart 
                                    data={caseData}
                                    margin={{
                                        top: 20,
                                        right: isMobileScreen? -25:0,
                                        left: isMobileScreen? -20:0,
                                        bottom: 0,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="year" />
                                    <YAxis yAxisId="left" stroke="#117554"
                                    // <YAxis yAxisId="left" stroke="#117554" label={{ value: 'จำนวนผู้ป่วย', angle: -90, position: 'insideLeft' }}
                                        allowDecimals={false}
                                        tick={{ dx: -2 }}
                                        tickFormatter={(tick) => {
                                            if(tick >= 1000 && tick < 1000000) return isMobileScreen?((tick / 1000) + 'K'):(Number(tick).toLocaleString('en-US'))
                                            else if (tick >= 1000000)return ((tick / 1000000) + 'M');
                                            else return tick;
                                        }}
                                    />
                                    <YAxis yAxisId="right" orientation="right" stroke="#b73238" />
                                    {/* <YAxis yAxisId="right" orientation="right" stroke="#b73238" label={{ value: 'อัตราผู้ป่วย', angle: -90, position: 'insideRight' }}/> */}
                                    <Tooltip />
                                    <Legend />
                                    <Bar yAxisId="left" dataKey="cases_count" fill="#117554" name="จำนวนผู้ป่วยสะสม" label={{ position: 'insideBottom', fill: '#fff'}}/>
                                    <Line yAxisId="right" type='linear' dataKey='rate' stroke='#b73238' label={{ position: 'top', fill: '#b73238'}} name={`อัตราป่วย (ต่อปชก. ${Number(populace).toLocaleString('en-US')} ราย)` }/> 

                                </ComposedChart>
                            </ResponsiveContainer> 
                        </div>
                    </div>
                </div>
                <div className="md:border md:rounded md:p-4 sm:border-b sm:pb-10 border-gray-300">
                    <Typography variant="h6" className="mb-4">สถานที่เสี่ยงในการแพร่ระบาดของโรคไข้เลือดออก {caseData.length > 0 ? `${getFieldNameByArea(state.setting.display.area.selected).prefix}${caseData[0][getFieldNameByArea(state.setting.display.area.selected).field]}` : ""} ณ สัปดาห์ที่ <strong className="text-red-900">{currentDate.week()} พ.ศ. {currentDate.format("BBBB")}</strong> </Typography>
                    <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-12">
                        <div className=" ">
                            <div className="">
                                <Typography variant="subtitle1" className="">ประเภทหมู่บ้าน/ชุมชน</Typography>
                                <Typography variant="subtitle2" className="text-gray-600">พิจารณาด้วยค่า HI</Typography>
                            </div>
                            {habitatRiskData.length > 0 ? (
                                <div className="w-full my-3 md:col-span-2 h-[400px] font-normal text-sm">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <ComposedChart 
                                            // layout="vertical"
                                            data={habitatRiskData}
                                            margin={{
                                                top: 20,
                                                right: 0,
                                                left: -30,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="place_type_name"/>
                                            <YAxis type="number" domain={[0, 100]} tickCount={6} tick={[0, 20, 40, 60, 80, 100]}
                                                tickFormatter={(tick) => {
                                                    return tick.toFixed(0);
                                                }}/>
                                            <Tooltip />
                                            {/* <Legend /> */}
                                            <Bar key={"safe_percent"} dataKey="safe_percent" stackId="habitat" fill="#117554" name="Safe" />
                                            <Bar key={"low_percent"} dataKey="low_percent" stackId="habitat" fill="#FABC3F" name="Low" />
                                            <Bar key={"moderate_percent"} dataKey="moderate_percent" stackId="habitat" fill="#FF6500" name="Moderate" />
                                            <Bar key={"hight_percent"} dataKey="hight_percent" stackId="habitat" fill="#b73238" name="High" />
                                        </ComposedChart>
                                    </ResponsiveContainer> 
                                </div>
                            ) : (
                                <div className="h-[367px] my-7 rounded content-center text-center bg-blue-gray-50">
                                    <Typography variant="body1">ไม่พบการสำรวจลูกน้ำยุงลาย</Typography>
                                </div>
                            )}
                            
                            <div className="flex justify-center gap-4 p-2 border rounded border-gray-300">
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#117554] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-1">Safe: HI = 0</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#FABC3F] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-1">{"Low: 0 < HI < 5"}</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#FF6500] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-grow">{"Moderate: 5 <= HI <= 50"}</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#b73238] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-grow">{"High: HI > 50"}</Typography>
                                </div>
                            </div>
                        </div>
                        <div className=" ">
                            <div className="">
                                <Typography variant="subtitle1" className="">ประเภทอื่นๆ</Typography>
                                <Typography variant="subtitle2" className="text-gray-600">พิจารณาด้วยค่า CI</Typography>
                            </div>
                            {otherRiskData.length > 0 ? (
                                <div className="w-full my-3 md:col-span-2 h-[400px] font-normal text-sm">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <ComposedChart 
                                            // layout="vertical"
                                            data={otherRiskData}
                                            margin={{
                                                top: 20,
                                                right: 0,
                                                left: -30,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="place_type_name"/>
                                            <YAxis type="number" domain={[0, 100]} tickCount={6} tick={[0, 20, 40, 60, 80, 100]}
                                                tickFormatter={(tick) => {
                                                    return tick.toFixed(0);
                                                }}/>
                                            <Tooltip/>
                                            {/* <Legend /> */}
                                            <Bar key={"safe_percent"} dataKey="safe_percent" stackId="habitat" fill="#117554" name="Safe" />
                                            <Bar key={"low_percent"} dataKey="low_percent" stackId="habitat" fill="#FABC3F" name="Low" />
                                            <Bar key={"hight_percent"} dataKey="hight_percent" stackId="habitat" fill="#b73238" name="High" />
                                        </ComposedChart>
                                    </ResponsiveContainer> 
                                </div>
                            ) : (
                                <div className="h-[367px] my-7 rounded content-center text-center bg-blue-gray-50">
                                    <Typography variant="body1">ไม่พบการสำรวจลูกน้ำยุงลาย</Typography>
                                </div>
                            )}
                            
                            <div className="flex justify-center gap-4 p-2 border rounded border-gray-300 mb-4">
                                <div className="flex items-center">
                                    <Typography variant="subtitle2" className="flex-1">*สถานศึกษา, สาธารณสุข</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#117554] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-1">Safe: CI = 0</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#b73238] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-grow">{"High: CI > 0"}</Typography>
                                </div>
                            </div>   
                            <div className="flex justify-center gap-4 p-2 border rounded border-gray-300">
                                <div className="flex items-center">
                                    <Typography variant="subtitle2" className="flex-1">อื่นๆ</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#117554] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-1">Safe: CI = 0</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#FABC3F] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-1">{"Low: 0 < CI < 5"}</Typography>
                                </div>
                                <div className="flex items-center">
                                    <div className="h-3 w-4 bg-[#b73238] mr-1"></div>
                                    <Typography variant="subtitle2" className="flex-grow">{"High: CI >= 5"}</Typography>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
                    
            </div>
            

            
        </Dialog>
    );
}

